module.exports = __webpack_public_path__ + "img/banner.be2f585f.png";